import firebase from 'firebase/app';
import 'firebase/messaging';

if ('undefined' === typeof window) {
    const firebaseApp = firebase.initializeApp(FIREBASE_CONFIG);
    const messaging = firebaseApp.messaging();
    messaging.onBackgroundMessage(() => {
        // Must be empty?
    });
}